import { Box, Divider, Flex, Typography, Image } from "@jewlr/storybook/core"
import styled from "styled-components"

import { IS_NA, IS_US } from "helpers/application"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

import CountrySelector from "./country-selector"

const FooterBottomIcon = styled(Box).attrs((props) => ({
  as: props.card ? "span" : "a",
}))`
  display: inline-block;
  vertical-align: middle;
  &:focus {
    outline-color: white;
  }
`

const FooterBottomImg = styled(Image).attrs({
  height: "24px",
})``
const FooterCopyright = styled(Typography)`
  color: white;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 24px;
  padding: 0 12px;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    text-align: left;
  `}
`
const SocialIcon = styled(Image)`
  height: 32px;
  width: 32px;
`
const SocialIconLink = styled(Box).attrs({
  as: "a",
})`
  &:focus {
    outline-color: white;
    border-radius: 50%;
  }
`
const FooterBottom = () => {
  return (
    <Box color="white" containWide px={{ _: 2, tablet: "60px" }}>
      <Divider bg="white" my="10px" />
      <Flex
        alignItems="center"
        flexDirection={{ _: "column", tablet: "row" }}
        justifyContent="space-between"
        px="10px"
        py={{ _: 3, tablet: "12px" }}
      >
        <Box mb={{ _: 3, tablet: 0 }}>
          <Typography
            fontSize="14px"
            fontWeight="600"
            letterSpacing="0.6px"
            mb={{ _: 2, desktop: 1 }}
            textAlign={{ _: "center", tablet: "left" }}
          >
            STAY CONNECTED
          </Typography>
          <Flex
            gutter={{ _: "10px", tablet: "5px" }}
            justifyContent="center"
            mx="0"
          >
            <SocialIconLink
              data-lc="footer"
              href="//facebook.com/jewlrcom/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                alt="facebook"
                src={require("images/layout/footer/connect/facebook_v2.svg")}
              />
            </SocialIconLink>
            <SocialIconLink
              data-lc="footer"
              href="//instagram.com/jewlr/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                alt="instagram"
                src={require("images/layout/footer/connect/instagram_v2.svg")}
              />
            </SocialIconLink>
            <SocialIconLink
              data-lc="footer"
              href="//pinterest.com/jewlrcom/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                alt="pinterest"
                src={require("images/layout/footer/connect/pinterest_v2.svg")}
              />
            </SocialIconLink>
            <SocialIconLink
              data-lc="footer"
              href="//www.youtube.com/channel/UC11M7JozPazDfSi4dMf_wOg"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                alt="youtube"
                src={require("images/layout/footer/connect/youtube_v2.svg")}
              />
            </SocialIconLink>
            <SocialIconLink
              data-lc="footer"
              href="//tiktok.com/@jewlr_official"
              rel="noopener noreferrer"
              target="_blank"
            >
              <SocialIcon
                alt="tiktok"
                src={require("images/layout/footer/connect/tiktok.svg")}
              />
            </SocialIconLink>
          </Flex>
        </Box>
        <CountrySelector />
      </Flex>
      <Divider bg="white" my="10px" />
      <Flex
        flexDirection={{ _: "column", tablet: "row" }}
        mb={3}
        pt={{ _: "12px", tablet: 5 }}
        px="10px"
      >
        <Flex gap="6px" justifyContent="center" mb={{ _: 1, tablet: 0 }}>
          <FooterBottomIcon
            data-lc="footer"
            href="https://www.bbb.org/kitchener/business-reviews/jewelers-retail/jewlrcom-in-thornhill-on-1275548#sealclick"
            rel="noopener"
            target="_blank"
            title="Better Business Bureau Accredited Business"
          >
            <FooterBottomImg
              alt="BBB"
              data-src={require("images/layout/footer/payment/BBB.svg")}
              src={require("images/icons/jewlr.gif")}
              width="63px"
            />
          </FooterBottomIcon>

          <FooterBottomIcon
            data-lc="footer"
            href="//sealserver.trustwave.com/cert.php?customerId=31e31d05f9944776b0cc1f1ce1ec6998&amp;size=65x36&amp;style=invert"
            marginLeft={{ _: "5px;" }}
            onClick={() => {
              window.open(
                "//sealserver.trustwave.com/cert.php?customerId=31e31d05f9944776b0cc1f1ce1ec6998&amp;size=65x36&amp;style=invert",
                "c_TW",
                "location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720"
              )
              return false
            }}
            rel="noopener"
            target="_blank"
            title="This site protected by Trustwave's Trusted Commerce program"
          >
            <FooterBottomImg
              alt="trustwave"
              data-src={require("images/layout/footer/payment/trustwave.svg")}
              height="21px"
              src={require("images/icons/jewlr.gif")}
              trustwave
              width="112px"
            />
          </FooterBottomIcon>

          <FooterBottomIcon
            data-lc="footer"
            href="https://www.jvclegal.org/"
            rel="noopener"
            target="_blank"
            title="Member of the Jewelers Vigilance Committee"
          >
            <FooterBottomImg
              alt="JVC"
              data-src={require("images/layout/footer/payment/JVC.svg")}
              src={require("images/icons/jewlr.gif")}
              width="85px"
            />
          </FooterBottomIcon>

          <FooterBottomIcon
            data-lc="footer"
            href="https://canadianjewellers.com/"
            rel="noopener"
            target="_blank"
            title="Canadian Jewellers Association"
          >
            <FooterBottomImg
              alt="Canadian Jewellers Association"
              data-src={require("images/layout/footer/payment/CJA.png")}
              src={require("images/icons/jewlr.gif")}
              width="74px"
            />
          </FooterBottomIcon>
        </Flex>

        <Flex gap="6px" justifyContent="center">
          <FooterBottomIcon card title="We accept payment with Visa">
            <FooterBottomImg
              alt="VISA"
              data-src={require("images/layout/footer/payment/VISA.svg")}
              src={require("images/icons/jewlr.gif")}
              width="39px"
            />
          </FooterBottomIcon>

          <FooterBottomIcon card title="We accept payment with Mastercard">
            <FooterBottomImg
              alt="mastercard"
              data-src={require("images/layout/footer/payment/mastercard.svg")}
              src={require("images/icons/jewlr.gif")}
              width="39px"
            />
          </FooterBottomIcon>

          {IS_NA() && (
            <FooterBottomIcon
              card
              title="We accept payment with American Express"
            >
              <FooterBottomImg
                alt="Amex"
                data-src={require("images/layout/footer/payment/Amex.svg")}
                src={require("images/icons/jewlr.gif")}
                width="37px"
              />
            </FooterBottomIcon>
          )}

          {IS_US() && (
            <FooterBottomIcon card title="We accept payment with Discover">
              <FooterBottomImg
                alt="discover"
                data-src={require("images/layout/footer/payment/discover.svg")}
                src={require("images/icons/jewlr.gif")}
                width="37px"
              />
            </FooterBottomIcon>
          )}

          {enableKlarnaCheckout() && (
            <FooterBottomIcon card title="We accept payment with Klarna">
              <FooterBottomImg
                alt="klarna"
                data-src={require("images/layout/footer/payment/klarna-white.svg")}
                src={require("images/icons/jewlr.gif")}
                width="45px"
              />
            </FooterBottomIcon>
          )}

          {sl.config.enable_paypal && (
            <FooterBottomIcon card title="We accept payment with PayPal">
              <FooterBottomImg
                alt="paypal"
                data-src={require("images/layout/footer/payment/paypal.svg")}
                src={require("images/icons/jewlr.gif")}
                width="39px"
              />
            </FooterBottomIcon>
          )}
        </Flex>
      </Flex>
      <FooterCopyright>
        Copyright © {new Date().getFullYear()} Jewlr. All rights reserved.
      </FooterCopyright>
    </Box>
  )
}
export default FooterBottom
